import styled from "@emotion/styled";
import { MenuProps } from "antd5";
import { Dropdown } from "antd5/lib";

import Button from "components/ui/button/Button";
import { toast } from "components/ui/toast/Toast";
import { useBidWorkflow } from "lib/hooks/api/bid/bids/useBidWorkflow";
import UIcon from "lib/icons/untitled_ui/UIcon";
import { useUpdateBids } from "../../lib/hooks/api/bid/bids/useUpdateBids";
import { pluralise } from "../../lib/utils";
import { renderStageOption } from "../shared/stage/stageSelectUtils";
import { processTransitions } from "../shared/stage/utils";

export function BidStageBulkUpdateButton({ selectedBidIds }: { selectedBidIds: string[] }) {
  const { data } = useBidWorkflow();
  const transitions = data ? processTransitions(data.transitions) : [];

  const { mutate: updateBids } = useUpdateBids({
    onSuccess: (data) => {
      const stageName = data.updateBids[0]?.stage?.name || "Unknown";
      toast.success(`${pluralise(data.updateBids.length, "bid")} changed to '${stageName}' stage`);
    },
    onError: () => {
      toast.error("Failed to update bid stage");
    },
  });

  const stageMenuItems: MenuProps["items"] = transitions.map((transition) => ({
    key: transition.label,
    type: "group",
    label: transition.label,
    children: transition.options.map((option) => ({
      key: option.value,
      label: renderStageOption(option.label, option.value, transitions),
      onClick: () => {
        if (!option.value) return;
        updateBids({
          updateBidsRequest: { ids: selectedBidIds, updateData: { stageId: option.value } },
        });
      },
    })),
  }));

  return (
    <Dropdown
      menu={{ items: stageMenuItems }}
      trigger={["click"]}
      dropdownRender={(menu) => <DropdownContainer>{menu}</DropdownContainer>}
    >
      <Button icon="alignTop02">
        Stage
        <UIcon icon="chevronDown" size={16} />
      </Button>
    </Dropdown>
  );
}

const DropdownContainer = styled.div({
  maxHeight: 300,
  overflow: "auto",
  borderRadius: 8,
  boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.12)",
});
